import { put, select, takeLatest } from 'redux-saga/effects'
import { getPatientMedicationsSelector } from '../selectors'
import { setPatientMedicationsList } from '../store/patientMedications.actions'
import { PatientMedicationsConstants } from '../store/patientMedications.constants'
import { IPatientMedicationsState } from '../store/patientMedications.types'

export function* setDoseUnits() {
  const patientMedications: IPatientMedicationsState = yield select(getPatientMedicationsSelector)
  const { doseUnits, patientMedication, patientMedicationsList } = patientMedications
  const selectedMedication = patientMedicationsList.filter((medication) => medication.key === patientMedication?.key)
  if (selectedMedication && selectedMedication.length) {
    selectedMedication[0].doseUnits = doseUnits
    yield put(setPatientMedicationsList(patientMedicationsList))
  }
}
export function* setDoseUnitsSaga() {
  yield takeLatest([PatientMedicationsConstants.SET_DOSE_UNITS], setDoseUnits)
}
